import { render, staticRenderFns } from "./ProductBreadcrumbs.vue?vue&type=template&id=29e90fbe&"
import script from "./ProductBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./ProductBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports